<div class="ui-reminder-date">
  <label>{{ 'account.reminder.IBAN.dialog.date' | translate }}</label>
  <div class="ui-reminder">
    <div class="ui-reminder-input">
      <a *ngIf="showPrevDateButton" class="ui-reminder-button" (click)="onDateTimeChange(changeType.DATE, dateDirection.PREVIOUS)"
        ><i class="icon-i-arrow-back"></i
      ></a>
      <p><i class="icon-i-calendar"></i>{{ day }}</p>
      <a class="ui-reminder-button" (click)="onDateTimeChange(changeType.DATE, dateDirection.NEXT)"><i class="icon-i-arrow-forward"></i></a>
    </div>
  </div>
</div>
<div class="ui-reminder-time">
  <label>{{ 'account.reminder.IBAN.dialog.time' | translate }}</label>
  <div class="ui-reminder">
    <div class="ui-reminder-input">
      <a *ngIf="showPrevTimeButton" class="ui-reminder-button" (click)="onDateTimeChange(changeType.TIME, dateDirection.PREVIOUS)"
        ><i class="icon-i-arrow-back"></i
      ></a>
      <p><i class="icon-i-time"></i>{{ time }}</p>
      <a class="ui-reminder-button" (click)="onDateTimeChange(changeType.TIME, dateDirection.NEXT)"><i class="icon-i-arrow-forward"></i></a>
    </div>
  </div>
</div>
